import song1 from "../Songs/piano/song1.mp3";
import song1_img from "../Songs/piano/song1_img.jpg";

import song2 from "../Songs/piano/song2.mp3";
import song2_img from "../Songs/piano/song2_img.jpg";

import song3 from "../Songs/piano/song3.mp3";
import song3_img from "../Songs/piano/song3_img.jpg";

import song4 from "../Songs/piano/song4.mp3";
import song4_img from "../Songs/piano/song4_img.jpg";

import song5 from "../Songs/piano/song5.mp3";
import song5_img from "../Songs/piano/song5_img.jpg";

let music = [
  {
    name: "Dance In The Game",
    songfile: song1,
    id: 300,
    songImage: song1_img,
    anime: "Classroom of the Elite",
    artist: "Piano",
  },
  {
    name: "Jujutsu Kaisen",
    songfile: song2,
    id: 301,
    songImage: song2_img,
    anime: "Re:Zero",
    artist: "Piano",
  },
  {
    name: "My Hero ",
    songfile: song3,
    id: 302,
    songImage: song3_img,
    anime: "My Hero",
    artist: "Piano",
  },
  {
    name: "Demon Slayer",
    songfile: song4,
    id: 303,
    songImage: song4_img,
    anime: "Demon Slayer",
    artist: "Pinao",
  },
  {
    name: "Unravel",
    songfile: song5,
    id: 304,
    songImage: song5_img,
    anime: "Tokyo Ghoul",
    artist: "Piano",
  },
];

export default music;
